// DS2026 dropdown menu styling — the floating-menu look used on data tables,
// the homepage, and entity action menus. Extracted here so every Radix
// dropdown (ActionsDropdown, the generic Dropdown, etc.) renders an identical
// surface instead of each copy drifting. Colors go through design tokens; the
// box-shadow is an arbitrary value because there is no shadow token for it.
//
// `!` important prefixes override the base classes baked into
// `BaseDropdown/dropdown-base.tsx`.

/** Floating menu surface: rounded-xl white card with a hairline neutral border
 *  (so the edges read against a white page) plus the DS2026 drop shadow. */
export const ds2026DropdownContentClass =
  '!rounded-xl !border !border-neutral-200 !bg-white !p-1.5 !shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.10),0px_2px_4px_-2px_rgba(16,24,40,0.06)]'

/** Default menu item: comfortable hit area, medium body text, gray hover. */
export const ds2026DropdownItemClass =
  '!flex !cursor-pointer !items-center !gap-2.5 !rounded-lg !px-3 !py-2 !text-base !font-medium !tracking-[-0.2px] !text-neutral-700 hover:!bg-neutral-100 hover:!text-neutral-900 focus:!bg-neutral-100 focus:!text-neutral-900'

/** Destructive menu item (delete, etc.): red tint that deepens on hover. */
export const ds2026DropdownItemDestructiveClass =
  '!flex !cursor-pointer !items-center !gap-2.5 !rounded-lg !px-3 !py-2 !text-base !font-medium !tracking-[-0.2px] !bg-error-bg-subtle !text-error-strong hover:!bg-error-bg-hover hover:!text-alert-danger-title focus:!bg-error-bg-hover focus:!text-alert-danger-title'

/** Divider between menu sections. */
export const ds2026DropdownSeparatorClass =
  '!my-1.5 !mx-0 !h-px !bg-neutral-200'

/** Trigger override for `ActionsDropdown.triggerClassName` when the ⋯ sits in a
 *  page header/toolbar beside full-size buttons. Promotes the compact table-row
 *  icon to a DS2026 secondary button (40px tall, white/Gray-300 outline, gray
 *  hover) so it reads as a peer of the other header buttons. */
export const ds2026DropdownTriggerButtonClass =
  '!h-10 !w-auto !rounded-md !border !border-ds2026-btn-outline-stroke !bg-ds2026-btn-outline-bg !px-3 !text-ds2026-btn-outline-text hover:!bg-ds2026-btn-outline-hover-bg hover:!text-ds2026-btn-outline-hover-text data-[state=open]:!bg-ds2026-btn-outline-hover-bg'
